"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebcamContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.WebcamContainer = styled_components_1.default.div `
  width: 100%;
  max-height: ${({ height }) => `${height}px`};
  text-align: center;

  video {
    width: ${({ width }) => `${width}px`};
    border-radius: 15px;
  }

  canvas {
    width: ${({ width }) => `${width}px`};
    height: ${({ height }) => `${height}px`};
    position: relative;
    bottom: 480px;
  }

  @media (max-width: 800px) {
    max-height: 200px;
    video,
    canvas {
      margin-left: auto;
      margin-right: auto;
      width: 250px;
    }
    canvas {
      bottom: 380px;
    }
  }
`;
//# sourceMappingURL=styles.js.map